import { Icon } from '@mage-ui/components';
import { icon, link } from '@mage-ui/styled-system/recipes';
import Link from 'next/link';

export const GoToCta = ({ text, slug, ...props }) => {
  //handle for scrolling without page reload
  const handleClick = (e) => {
    if (!slug || slug === '#') {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else if (slug.startsWith('#')) {
      e.preventDefault();
      const target = document.querySelector(slug);
      if (target) {
        target.scrollIntoView({ behavior: 'auto', block: 'start' });
      }
    }
  };
  return (
    text && (
      <Link
        onClick={handleClick}
        href={slug || '#'}
        className={link({ size: 's', variant: 'underlined' })}
        {...props}
      >
        {text}
        <Icon name='arrow_upward' classNames={icon({ size: 'm' })} />
      </Link>
    )
  );
};
